import { all } from 'redux-saga/effects'
import authSaga from '@/store/sagas/auth.saga'
import statisticsSaga from '@/store/sagas/statistics.saga'
import tableDataSaga from '@/store/sagas/table.saga'

export default function* rootSaga(): any {
    yield all([authSaga(), statisticsSaga(), tableDataSaga()])
}
